import React, { useCallback, useEffect, useRef, useState } from 'react';
import { OwcIconButton } from '@one/react';

const buttonStyle = {
  position: 'fixed',
  bottom: '30px',
  right: '100px',
  zIndex: 2000,
  backgroundColor: 'white',
  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  borderRadius: '50%',
  padding: '10px',
};

// Show the button once the scroller has moved past this many pixels.
const SCROLL_THRESHOLD_PX = 150;

export default function MoveToTop({ scrollSelector = '.middle-content-container' }) {
  const [visible, setVisible] = useState(false);
  const scrollerRef = useRef(null);

  useEffect(() => {
    const scroller = document.querySelector(scrollSelector);
    scrollerRef.current = scroller;
    if (!scroller) return undefined;

    const handleScroll = () => setVisible(scroller.scrollTop > SCROLL_THRESHOLD_PX);
    handleScroll(); // sync initial state in case it is already scrolled

    scroller.addEventListener('scroll', handleScroll, { passive: true });
    return () => scroller.removeEventListener('scroll', handleScroll);
  }, [scrollSelector]);

  const scrollToTop = useCallback(() => {
    scrollerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!visible) return null;

  return (
    <div style={buttonStyle}>
      <OwcIconButton
        icon="to_the_top"
        family="outlined"
        variant="filled"
        onClick={scrollToTop}
        size="medium"
        aria-label="Scroll to top"
      />
    </div>
  );
}
